import { Button, Icon, Theme } from "@outschool/backpack";
import { ClassDetailsNoSectionsQuery } from "@outschool/gql-frontend-generated";
import { faPlayCircle } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { useTrackEvent } from "@outschool/ui-analytics";
import React from "react";

export const WatchMyTeacherVideoLink = ({
  activity,
  openModal
}: {
  activity?: ClassDetailsNoSectionsQuery["activity"];
  openModal: (arg: boolean) => void;
}) => {
  const { t } = useTranslation(
    "client\\components\\detailPage\\subcomponents\\WatchMyTeacherVideoLink"
  );
  const segmentTrack = useTrackEvent();

  const handlePlayClick = () => {
    segmentTrack("Opened teacher video modal", {
      activityUid: activity?.uid
    });
    openModal(true);
  };

  return (
    <Button
      variant="link"
      startIcon={<Icon icon={faPlayCircle} />}
      onClick={handlePlayClick}
      sx={(theme: Theme) => ({
        marginTop: "1em",
        [theme.breakpoints.down("md")]: {
          marginTop: "0.5em",
          alignSelf: "flex-start"
        }
      })}
    >
      {t`Watch my teacher video!`}
    </Button>
  );
};
